import Axios from "axios";
import {initFreightForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import Swal from "sweetalert2";

function initPublicFreightsCreate() {
	const freightForm =
		initFreightForm(document.querySelector('.freight-form'));

	document.querySelector('.create-new-freight-button').onclick = createNewFreight;

	/** Methods */

	function createNewFreight() {
		Swal.fire({
			title: 'Submit Carrier Data?',
			icon: 'question',
			showCancelButton: true,
		}).then(result => {
			if (result.isConfirmed) {
				const freightData = freightForm.inputs();
				freightForm.clearFeedbacks();

				if (freightForm.validate() === false) {
					return;
				}

				loading();
				Axios.post(freightForm.postUrl(), freightData)
					.then(handleAjaxSuccess)
					.catch(freightForm.handleValidationErrors)
					.finally(stopLoading)
			}
		})
	}
}

export {initPublicFreightsCreate}
